<template>
  <div class="admin-atribuir">
    <!-- Cabeçalho -->
    <header class="header">
      <h1 class="titulo">📍 Atribuir Funcionários</h1>
      <p class="subtitulo">Localização: <strong>{{ localizacao?.nome }}</strong></p>
    </header>

    <!-- Loading inicial -->
    <div v-if="loadingLocalizacao || loadingFuncionarios" class="loading-state">
      <div class="spinner"></div>
      <p>Carregando informações...</p>
    </div>

    <!-- Após carregar -->
    <div v-else>
      <!-- Busca -->
      <div class="filtro-box">
        <input
          v-model="busca"
          type="text"
          placeholder="Buscar funcionário..."
          class="input-busca"
        />
      </div>

      <!-- Botão Selecionar Todos -->
      <div class="acoes-selecao">
        <button class="btn-selecionar-todos" @click="toggleSelecionarTodos">
          {{ todosSelecionados ? "Limpar Seleção" : "Selecionar Todos" }}
        </button>
      </div>

      <!-- Nenhum funcionário -->
      <div v-if="funcionariosFiltrados.length === 0" class="empty-state">
        <i class="fas fa-user-slash empty-icon"></i>
        <h3>Nenhum funcionário encontrado</h3>
      </div>

      <!-- Lista -->
      <div v-else class="funcionarios-list">
        <label
          v-for="f in funcionariosFiltrados"
          :key="f.id"
          class="funcionario-item"
        >
          <input type="checkbox" :value="f.id" v-model="funcionariosSelecionados" />
          <span>{{ f.nome }} — <small>{{ f.cargo || "Sem cargo" }}</small></span>
        </label>
      </div>

      <!-- Botões -->
      <div class="acoes">
        <button class="btn-principal" @click="salvarAtribuicao" :disabled="salvando">
          {{ salvando ? "Salvando..." : "Salvar Atribuição" }}
        </button>

        <button class="btn-voltar" @click="$router.back()">Voltar</button>
      </div>
    </div>
  </div>
</template>

<script>
import { adminService } from "@/services/adminService";

export default {
  name: "AtribuirLocalizacao",

  data() {
    return {
      localizacao: null,
      funcionarios: [],
      funcionariosSelecionados: [],
      busca: "",

      loadingLocalizacao: false,
      loadingFuncionarios: false,
      salvando: false,
    };
  },

  computed: {
    funcionariosFiltrados() {
      if (!this.busca.trim()) return this.funcionarios;

      const termo = this.busca.toLowerCase();
      return this.funcionarios.filter((f) =>
        f.nome.toLowerCase().includes(termo)
      );
    },

    // Detecta se todos os filtrados estão selecionados
    todosSelecionados() {
      return (
        this.funcionariosFiltrados.length > 0 &&
        this.funcionariosFiltrados.every((f) =>
          this.funcionariosSelecionados.includes(f.id)
        )
      );
    },
  },

  methods: {
    async carregarLocalizacao() {
      this.loadingLocalizacao = true;
      try {
        const id = this.$route.params.id;
        const r = await adminService.obterLocalizacaoPorId(id);
        this.localizacao = r.data;
      } catch (err) {
        alert("Erro ao carregar localização.");
      } finally {
        this.loadingLocalizacao = false;
      }
    },

    async carregarFuncionarios() {
      this.loadingFuncionarios = true;
      try {
        const r = await adminService.listFuncionarios();
        this.funcionarios = r.data;
      } catch (err) {
        alert("Erro ao carregar funcionários.");
      } finally {
        this.loadingFuncionarios = false;
      }
    },

    toggleSelecionarTodos() {
      if (this.todosSelecionados) {
        // remover todos os filtrados
        this.funcionariosSelecionados = this.funcionariosSelecionados.filter(
          (id) => !this.funcionariosFiltrados.some((f) => f.id === id)
        );
      } else {
        // adicionar todos os filtrados
        const ids = this.funcionariosFiltrados.map((f) => f.id);
        this.funcionariosSelecionados = [
          ...new Set([...this.funcionariosSelecionados, ...ids]),
        ];
      }
    },

    async salvarAtribuicao() {
      if (this.funcionariosSelecionados.length === 0) {
        return alert("Selecione pelo menos um funcionário.");
      }

      this.salvando = true;
      try {
        await adminService.atribuirFuncionariosLocalizacao(
          this.localizacao.id,
          this.funcionariosSelecionados
        );
        alert("Atribuições salvas com sucesso!");
        this.$router.back();
      } catch (err) {
        console.error(err);
        alert("Erro ao salvar atribuições.");
      } finally {
        this.salvando = false;
      }
    },
  },

  mounted() {
    this.carregarLocalizacao();
    this.carregarFuncionarios();
  },
};
</script>

<style scoped>
.admin-atribuir {
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem 1rem;
  background: #f8fafc;
  min-height: 100vh;
  font-family: "Inter", sans-serif;
}

.header {
  text-align: center;
  margin-bottom: 1rem;
}
.titulo {
  font-size: 1.6rem;
  font-weight: 700;
  color: #1e293b;
}
.subtitulo {
  color: #475569;
  font-size: 1rem;
}

.filtro-box {
  margin-bottom: 1rem;
}
.input-busca {
  width: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  padding: 0.7rem;
  font-size: 1rem;
}

/* Botão Selecionar Todos */
.acoes-selecao {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
}
.btn-selecionar-todos {
  background: #6366f1;
  color: white;
  border: none;
  padding: 0.6rem 1rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;
}
.btn-selecionar-todos:hover {
  background: #4f46e5;
}

.funcionarios-list {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
}

.funcionario-item {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  background: white;
  padding: 0.8rem;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid #e2e8f0;
  cursor: pointer;
}
.funcionario-item:hover {
  background: #f1f5f9;
}

.acoes {
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.btn-principal {
  background: #10b981;
  color: white;
  padding: 0.9rem;
  border-radius: 10px;
  border: none;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;
}
.btn-principal:hover {
  background: #059669;
}

.btn-voltar {
  background: #e2e8f0;
  color: #1e293b;
  padding: 0.9rem;
  border-radius: 10px;
  border: none;
  font-weight: 600;
}
.btn-voltar:hover {
  background: #cbd5e1;
}

.loading-state,
.empty-state {
  text-align: center;
  padding: 2rem;
  color: #475569;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  margin: 0 auto 1rem;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.empty-icon {
  font-size: 2.5rem;
  color: #cbd5e1;
  margin-bottom: 1rem;
}
</style>
